/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUp = createReactComponent("arrow-up", "IconArrowUp", [
  ["path", { d: "M12 5l0 14", key: "svg-0" }],
  ["path", { d: "M18 11l-6 -6", key: "svg-1" }],
  ["path", { d: "M6 11l6 -6", key: "svg-2" }]
]);

export { IconArrowUp as default };
//# sourceMappingURL=IconArrowUp.js.map
